import { ICaseModel, IDepositionModel } from '../../../interfaces/ICase';

import { CaseDepositionList } from './CaseDepositionList';
import { IAssociatedOrganizationModel } from '../../../interfaces/IOrganization';
import { IUserModel } from '../../../interfaces/IUser';
import { useGetDepositionCategories } from '../../../shared/react-query-hooks/useGetDepositionCategories';
import { useGetDepositionStatusTypes } from '../../../shared/react-query-hooks/useGetDepositionStatusTypes';
import { useZoneContext } from '../../../contexts/useZoneContext';

export interface ICaseDepositionListWrapperProps {
    allDefenseCounselsForZone: IAssociatedOrganizationModel[];
    caseGuid?: string;
    currentCase?: ICaseModel;
    depositions: IDepositionModel[];
    forceHideDelete?: boolean;
    forceHideEdit?: boolean;
    getEasyUpdateIconColorStyle?: (caseGuid: string) => string;
    onDepositionsChange?: (depositions: IDepositionModel[]) => void;
    onEasyUpdateClick?: (caseGuid: string) => void;
    readonly?: boolean;
    showCaseColumn?: boolean;
    showEasyUpdateColumn?: boolean;
    user: IUserModel;
    usersInZone: IUserModel[];
    isQuadScope?: boolean;
}

export function CaseDepositionListWrapper(props: ICaseDepositionListWrapperProps) {
    const depositionStatusTypes = useGetDepositionStatusTypes();
    const depositionCategories = useGetDepositionCategories();
    const zoneContext = useZoneContext();

    const isLoading = depositionStatusTypes.isLoading || depositionCategories.isLoading;
    if (isLoading) return <div>Loading Depositions...</div>;

    return (
        <CaseDepositionList
            allDefenseCounselsForZone={props.allDefenseCounselsForZone}
            caseGuid={props.caseGuid ?? ''}
            categories={depositionCategories.data ?? []}
            currentCase={props.currentCase}
            depositions={props.depositions}
            forceHideDelete={props.forceHideDelete}
            getEasyUpdateIconColorStyle={props.getEasyUpdateIconColorStyle}
            hideEdit={props.forceHideEdit}
            onDepositionsChange={props.onDepositionsChange}
            onEasyUpdateClick={props.onEasyUpdateClick}
            showCaseColumn={props.showCaseColumn}
            showEasyUpdateColumn={props.showEasyUpdateColumn}
            statusTypes={depositionStatusTypes.data ?? []}
            user={props.user}
            usersInZone={props.usersInZone}
            readonly={props.readonly}
            zoneContext={zoneContext}
            isQuadScope = {props.isQuadScope!!}
        />
    );
}
